<template>
  <v-dialog v-if="file" v-model="show" content-class="view-image" width="800px">
    <v-card>
      <vue-pdf-embed
        v-if="file.mime_type === 'application/pdf'"
        :source="file.url"
      />
      <v-img v-else :src="file.url" />
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  name: 'Uploads',

  components: {
    VuePdfEmbed
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },

    file: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      show: this.value,
      loading: false,
      close: mdiClose
    }
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .view-image {
  max-width: 1080px;
  box-shadow: none;

  &__border {
    height: 100%;
    text-align: center;
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .v-window__prev,
  .v-window__next {
    visibility: hidden;
  }
}
</style>
